import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ApexChart, ApexNonAxisChartSeries, ApexResponsive, ChartComponent} from 'ng-apexcharts';
import {FormControl, FormGroup} from "@angular/forms";
import {TranslateService} from "../../../../../../shared/services/translate.service";
import {SchoolProgramService} from "../../../../../../shared/services/school-program.service";
import {SchoolProgramModel} from "../../../../../../shared/models/school-program-model";
import {SchoolProgramCategoryModel} from "../../../../../../shared/models/school-program-category-model";


export interface ChartOptions {
  chart: ApexChart;
  series: ApexNonAxisChartSeries;
  labels: string[];
  responsive: ApexResponsive[];
}

@Component({
  selector: 'app-school-program-category-chart',
  templateUrl: './school-program-category-chart.component.html',
  styleUrls: ['./school-program-category-chart.scss'],

})
export class SchoolProgramCategoryChart implements OnInit, OnChanges {
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions !: Partial<ChartOptions> | any;
  @Input()
  academic_year = null;
  constructor(
      private schoolProgramService: SchoolProgramService,
      private translate: TranslateService,
      private cd: ChangeDetectorRef
  ) {
    translate.load("extracurricular");

    this.chartOptions = {
      chart: {
        width: 450,
        type: "pie"
      },
      fill: {
        type: "gradient"
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    };
  }

  paramForm: FormGroup;
  selectedSchoolLevel = null;
  dataSchoolProgram = [];
  hasData: boolean = false;
  task = null;
  loading = false;

  ngOnInit() {
    this.initForm();
  }
  initForm() {
    this.paramForm = new FormGroup({
      'name': new FormControl(null),
      'academic_year': new FormControl(null),
      'period_id': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'year_level_id': new FormControl(null),
      'school_level_relation_id': new FormControl(null)
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['academic_year'] && !changes['academic_year'].firstChange) {
      this.resetSchoolLocation();
    }
  }

  resetSchoolLocation() {
    this.paramForm.controls['school_location_id'].setValue(null);
  }
  onChangeSchoolLevelRelation(item: any) {
    this.paramForm.controls['school_location_id'].markAsTouched();
    this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.paramForm.controls['school_level_id'].markAsTouched();
    this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

    this.selectedSchoolLevel = item ? item.school_level_id : null;

    if (this.paramForm.value.school_level_id) {
      this.getActivityTotal();
    }
  }

  getActivityTotal(index = null) {
    this.loading = true;
    this.hasData = false;
    if (!index) {
      this.schoolProgramService.getSchoolProgramTotalActivities({
        academic_year: this.academic_year,
        school_location_id: this.paramForm.value.school_location_id || null,
      })
          .subscribe(
              (response: SchoolProgramModel[]) => {
                // @ts-ignore
                if (response['status']) {
                  // @ts-ignore
                  this.dataSchoolProgram = response['data'].slice();
                  this.hasData = this.dataSchoolProgram.length > 0;
                  const categoryList = this.dataSchoolProgram.map((i: any) => i.school_program_name);
                  const totalValues = this.dataSchoolProgram.map((i: any) => +i.total);
                  this.chartOptions.series = totalValues;
                  this.chartOptions.labels = categoryList;
                  this.chartOptions.events =
                    {
                      dataPointSelection: (event: any, chartContext: any, config: any) => {
                        const selectedIndex = config.dataPointIndex;
                        // @ts-ignore
                        this.getActivityTotal(this.dataSchoolProgram[selectedIndex].school_program_id);
                      }
                    }
                  this.loading = false;
                  this.cd.detectChanges();
                } else {
                  this.loading = false;
                  // this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
                }
              },
              error => {
                this.loading = false;
                // this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
              });
    } else {
      this.schoolProgramService.getSchoolProgramCategoryTotalActivities({
        school_program_id: index
      })
          .subscribe(
              (response: SchoolProgramCategoryModel[]) => {
                // @ts-ignore
                if (response['status']) {
                  // @ts-ignore
                  this.dataSchoolProgram = response['data'].slice();
                  this.hasData = this.dataSchoolProgram.length > 0;
                  const categoryList = this.dataSchoolProgram.map((i: any) => i.category_name);
                  const totalValues = this.dataSchoolProgram.map((i: any) => +i.total);
                  this.chartOptions.series = totalValues;
                  this.chartOptions.labels = categoryList;
                  this.loading = false;
                  this.cd.detectChanges();
                } else {
                  this.loading = false;
                  // this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
                }
              },
              error => {
                this.loading = false;
                // this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
              });
    }

  }


}


